import CustomCard from '@/components/customCard';
import UpdateTextStyle from '@/components/UpdateTextStyle';
import { TextAppearanceKeys, TextEmphasisKeys, TextSizeKeys } from '@/constants/enum';

interface IProps {
  isRequired?: boolean;
  textSize: TextSizeKeys;
  textAppearance: TextAppearanceKeys;
  textEmphasis: TextEmphasisKeys;
  changeTextSize: (value: TextSizeKeys) => void;
  changeTextAppearance: (value: TextAppearanceKeys) => void;
  changeTextEmphasis: (value: TextEmphasisKeys) => void;
  defaultOpen?: boolean;
}

export default function TextStyle(props: IProps) {
  return (
    <CustomCard required={props.isRequired} title="Text style">
      <UpdateTextStyle
        changeTextAppearance={props.changeTextAppearance}
        changeTextEmphasis={props.changeTextEmphasis}
        changeTextSize={props.changeTextSize}
        textAppearance={props.textAppearance}
        textEmphasis={props.textEmphasis}
        textSize={props.textSize}
      />
    </CustomCard>
  );
}
